import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { Configure2FALayout } from '../Configure2FALayout';
import { Configure2FADeviceRecoveryPins, Configure2FADeviceRecoveryPinsProps } from './Configure2FADeviceRecoveryPins';

export interface Configure2FADeviceSuccessProps extends Configure2FADeviceRecoveryPinsProps {
    onSuccess: () => void;
}

export function Configure2FADeviceSuccess({ recoveryPins, onSuccess }: Configure2FADeviceSuccessProps) {
    return (
        <Configure2FALayout title={TextKey.RecoveryCodes} subtitle={TextKey.RecoveryCodesIntro}>
            <Stack spacing="400" vertical>
                <Configure2FADeviceRecoveryPins recoveryPins={recoveryPins} />
                <Stack alignment="end">
                    <Button onClick={onSuccess} variant="primary" size="medium" type="submit">
                        <LocalizedText textKey={TextKey.Done} />
                    </Button>
                </Stack>
            </Stack>
        </Configure2FALayout>
    );
}
